import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Grid } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import DeleteModal from "../../components/Common/DeleteModal";
import Notification from "../../components/Common/Notification";
import Helpers from "../../helpers/helpers";

import moment from "moment";
import Label from "../../components/Common/Label";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import CustomDateRangePicker from "../../components/Form/CustomDateRangePicker";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import { exportCustomerReport, getCustomerReport, resetReportAttachmentState, resetReportState } from "../../store/actions";
import "./report.css";

const CustomerReport = ({ customerReportListing, customerReportDocument, userPermission }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [loading, setLoading] = useState(false);
    const [filterStatus, setFilterStatus] = useState("all");
    const [categoryFilter, setCategoryFilter] = useState("");
    const [sort_by, setSortBy] = useState('id');
    const [dateModalOpen, setDateModalOpen] = useState(false);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [dateRange, setDateRange] = useState([null, null]);
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [sort, setSorted] = useState("asc")
    const [exportable, setExportable] = useState(false);
    const [viewable, setViewable] = useState(false);

    const [content, setContent] = useState({
        open: false,
        title: "",
        msg: "",
        buttonTitle: "",
        action: "",
        id: "",
    })

    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("export-reporting") && setExportable(true);
            userPermission?.includes("view-reporting") && setViewable(true);
            !userPermission?.includes("view-reporting") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        dispatch(resetReportState());
    }, [])

    useEffect(() => {
        initData();
    }, [page, length, sort, sort_by, filterStatus, startDate, endDate])

    useEffect(() => {
        if (customerReportDocument?.code === 'success' && customerReportDocument?.excel_base64) {
            Helpers.handleDownloadExcelFile(customerReportDocument.excel_base64, 'customer_report_listing');
            dispatch(resetReportAttachmentState());
        }
        setLoading(false);
    }, [customerReportDocument])

    const initData = () => {
        dispatch(getCustomerReport({
            sort: sort || '',
            sort_by: sort_by || '',
            status: filterStatus || '',
            from_date: startDate || '',
            to_date: endDate || '',
            page: page,
            length: length,
        }))
    }

    const getLengthPage = (page, length) => {
        setPage(page)
        setLength(length)
    }

    const handleSetDateRange = (e) => {
        setPage("1");
        if (e) {
            setDateRange(e);
            setStartDate(moment(e[0]).format('YYYY-MM-DD'));
            setEndDate(moment(e[1]).format('YYYY-MM-DD'));
        } else {
            setDateRange(null);
            setStartDate(null);
            setEndDate(null);
        }
    }

    const handleExport = () => {
        let filter = {
            sort: sort_by || '',
            sort_order: sort || '',
            status: filterStatus || '',
            created_date_from: startDate || '',
            created_date_to: endDate || '',
        }
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all' || filter[key] === 0) {
                delete filter[key];
            }
        });
        dispatch(exportCustomerReport(filter))
        setLoading(true);
    }

    const resetFilter = () => {
        setPage("1");
        setDateRange([]);
        setStartDate(null);
        setEndDate(null);
        setFilterStatus('all');
        setCategoryFilter('');
    }

    const header = [
        {
            Header: "Customer",
            columnID: "name",
            accessor: (cellProps) => {
                return (
                    <div>
                        <Link className="clickable-text" to={`/edit-customer/${cellProps?.id}`} >{cellProps?.name || '-'}</Link>
                        <div>{cellProps.email}</div>
                    </div>
                )
            },
            minWidth: 150,
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Total orders",
            columnID: "orders_count",
            accessor: (cellProps) => {
                return (
                    <div>{cellProps?.orders_count || '0'}</div>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Amount spend(S$)",
            accessor: (cellProps) => {
                return (
                    <div>{cellProps?.orders_sum_order_amount || '0.00'}</div>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Points earned",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div>{cellProps?.orders_sum_earned_points_given || '0'}</div>
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Last purchased date",
            accessor: (cellProps) => {
                return (
                    <div>{cellProps?.orders_max_created_at ? moment(cellProps?.orders_max_created_at).format("DD MMM YYYY") : '-'}</div>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Account status",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <Label.StatusLabel label={cellProps?.status === 1 ? 'active' : 'inactive'} marginLeft={"0px"} />
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
    ]

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item lg={10} md={10} sm={12} spacing={1} className="d-flex align-items-center">
                    <Grid item lg={3.5} md={5} xs={12}>
                        <CustomDateRangePicker
                            open={() => setDateModalOpen(true)}
                            close={() => setDateModalOpen(false)}
                            isOpen={dateModalOpen}
                            startDate={(startDate && moment(startDate).format('DD MMM YYYY')) || 'dd/mm/yyyy'}
                            endDate={(endDate && moment(endDate).format("DD MMM YYYY")) || 'dd/mm/yyyy'}
                            handleSetDateRange={handleSetDateRange}
                            value={dateRange}
                        />
                    </Grid>
                    <Grid item lg={3} md={3.5} xs={12}>
                        <CustomSelect2
                            values={filterStatus || "all"}
                            onChange={(e) => { setPage("1"); setFilterStatus(e) }}
                            data={Helpers.status}
                            placeholder={"All statuses"}
                        />
                    </Grid>
                    <Grid item lg={5.5} md={3.5} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                {exportable && <Grid item lg={2} md={2} sm={3} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }} alignItems={'center'}>
                    <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />
                </Grid>}
            </Grid>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content textColor" style={{ minHeight: 850 }}>
                <LoadingDialog open={loading || !customerReportListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <DeleteModal setContent={setContent} content={content} />
                    <div className="header mb-2">Customer Report</div>
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={customerReportListing?.data || []}
                        getLengthPage={getLengthPage}
                        pageSize={length}
                        totalPage={customerReportListing?.last_page || 1}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={customerReportListing?.last_page || 1}
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

function mapStateToProps({ Report, Login }) {
    return {
        customerReportListing: Report.customerReportListing.customers,
        customerReportDocument: Report.customerReportDocument,
        userPermission: Login.permissionArry,
    };
}

export default connect(mapStateToProps)(CustomerReport);
